"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.REG_FORM_VALUE_WHITELIST = void 0;
// These fields will have their values tracked on change.
// Take care not to transmit any PII
const REG_FORM_VALUE_WHITELIST = exports.REG_FORM_VALUE_WHITELIST = ['patient.phone.type'];